module.exports = __webpack_public_path__ + "static/media/course_03.c5fcfeb8.jpg";